import { useState, useEffect } from 'react';
import { $getSelection, $isRangeSelection, FORMAT_TEXT_COMMAND } from 'lexical';
import { useRichTextEditor } from '../RichTextEditorProvider';
import { IconButton, Tooltip } from '@sweep-io/sweep-design';
import { TextBolder } from '@sweep-io/sweep-design/dist/icons';

export const BoldButton = () => {
  const { editor } = useRichTextEditor();
  const [isBold, setIsBold] = useState(false);

  useEffect(() => {
    return editor.registerUpdateListener(({ editorState }: any) => {
      editorState.read(() => {
        const selection = $getSelection();
        if ($isRangeSelection(selection)) {
          setIsBold(selection.hasFormat('bold'));
        }
      });
    });
  }, [editor]);

  return (
    <Tooltip title="Bold (Ctrl+B)">
      <IconButton
        variant="squared"
        size="small"
        onClick={() => {
          editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'bold');
        }}
        pressed={isBold}
      >
        <TextBolder />
      </IconButton>
    </Tooltip>
  );
};
